import { useEffect } from "react";


export default function useSetDrawer(isOpen : boolean ,  onDismiss: () => void) {
    useEffect(() => {
        if (isOpen) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = 'auto';
        }
      }, [isOpen]);
      //@ts-ignore
      const handleDragEnd = (_, info) => {
        const {offset, velocity} = info;
        if (offset.y > 100 || velocity.y > 500) {
          onDismiss();
        }
      };
  return {handleDragEnd}
}
